/* eslint no-eval: 0 */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import * as actions from '../../../../../store';
import { Typography, FormControl, InputLabel, Select, MenuItem, Button, Menu, Chip } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  chipContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    height: '100%',
  },
}));

const QualityFeatures = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // Store state
  const qualityOverlaysToShow = useSelector((state) => state.images.qualityOverlaysToShow);
  const shownQualityOverlayType = useSelector((state) => state.labeling.shownQualityOverlayType);

  //Local state
  const [selectedClipOption, setSelectedClipOption] = useState('clips');

  const handleChipClick = (key) => {
    handleLesionsChange({ target: { value: key } });
  };

  const lesions = {
    parenchyma: {
      label: t('ResultView.parenchyma'),
      color: theme.palette.qualityClasses.parenchyma,
      show: qualityOverlaysToShow.parenchymaRCC,
    },
    pectoralis: {
      label: t('ResultView.pectoralis'),
      color: theme.palette.qualityClasses.pectoralis,
      show: qualityOverlaysToShow.pectoralisRCC,
    },
    skinFolds: {
      label: t('ResultView.skin_folds'),
      color: theme.palette.qualityClasses.skinFolds,
      show: qualityOverlaysToShow.skinFoldsRCC,
    },
    clips: {
      label: t('ResultView.clips'),
      color: theme.palette.qualityClasses.clips,
      show: qualityOverlaysToShow.clipsRCC,
    },
  };

  const handleLesionsChange = (e) => {
    if (shownQualityOverlayType === e.target.value) {
      dispatch(actions.hideAllLesions());
      dispatch(actions.setShownQualityOverlayType(''));
      dispatch(actions.setQualityInDrawingMode(false));
    } else {
      dispatch(actions.setShownQualityOverlayType(e.target.value));
      dispatch(actions.showOverlayOfKind(e.target.value));
      dispatch(actions.setQualityInDrawingMode(true));
    }
  };

  return (
    <div className={classes.chipContainer}>
      {Object.entries(lesions).map(([key, item]) => (
        <Chip
          size='small'
          key={key}
          label={item.label}
          variant='outlined'
          style={{
            backgroundColor: shownQualityOverlayType === key ? item.color : `${item.color}10`,
            color: shownQualityOverlayType === key ? theme.palette.texts.generalTexts : item.color,
            letterSpacing: '0.1rem',
            height: '22px',
            width: '15%',
            boxShadow: shownQualityOverlayType === key && 'rgb(72 72 72 / 89%) 1px 1px 4px 0px',
            fontWeight: shownQualityOverlayType === key && 'bold',
            borderRadius: '5px',
            border: `1px solid ${item.color}`,
          }}
          onClick={(e) => handleChipClick(key)}
        />
      ))}
    </div>
  );
};

export default QualityFeatures;
